'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Down = require('./Down');

var _Down2 = _interopRequireDefault(_Down);

var _Up = require('./Up');

var _Up2 = _interopRequireDefault(_Up);

var _SortArrows = require('./SortArrows');

var _SortArrows2 = _interopRequireDefault(_SortArrows);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  Down: _Down2.default,
  Up: _Up2.default,
  SortArrows: _SortArrows2.default
}; /*
    * Exports
    */


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/base/icons/lib/components/Arrows/medium/index.js
// module id = 63
// module chunks = 0 1 2 3 4 5 6 7 8 9